import * as React from "react";

import { H1 } from "@blueprintjs/core";

import { css } from "glamor";

import { getAllFights, getAllParticipants, getFight, getJurors, getTeams } from "../api";
import { Fight, FilterItem, Juror, Participant, Team } from "../Interfaces";

import * as _ from "lodash";
import Loading from "src/Loading";
import FightPlanCard from "./FightPlanCard";
import FightPlanFilter from "./FightPlanFilter";

const styles = {
	container: css({
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
	}),
	element: css({
		minWidth: "300px",
		flexBasis: "500px",
		flexGrow: 1,
	}),
	title: css({ textAlign: "left" }),
	mobileMargin: css({
		"@media (max-width: 780px)": {
			marginLeft: "20px",
			marginRight: "20px",
		},
	}),
};

interface State {
	fights: Fight[];
	participants: Participant[];
	teams: Team[];
	jurors: Juror[];
	selectedFilterItem: FilterItem;
	showJurors: number | undefined;
}

interface Props {
	dark: boolean;
}

const filterFights = (fights: Fight[], selectedFilterItem: FilterItem): Fight[] => {
	if (!selectedFilterItem.type) {
		return fights;
	}
	let filteredFights = [] as Fight[];
	if (selectedFilterItem.type === "Participant") {
		filteredFights = fights.filter((fight) =>
			Object.keys(fight.participants).includes(selectedFilterItem.id.toString())
		);
	} else if (selectedFilterItem.type === "Juror") {
		filteredFights = fights.filter((fight) =>
			Object.keys(fight.jurors).includes(selectedFilterItem.id.toString())
		);
	} else {
		filteredFights = fights.filter((fight) =>
			Object.keys(fight.teams).includes(selectedFilterItem.id.toString())
		);
	}

	return filteredFights;
};

export default class FightPlan extends React.Component<Props, State> {
	public state = {
		showJurors: undefined,
		fights: [] as Fight[],
		participants: [] as Participant[],
		jurors: [] as Juror[],
		teams: [] as Team[],
		selectedFilterItem: {} as FilterItem,
	};
	public async componentDidMount() {
		const fightList = await getAllFights();
		const fights = await Promise.all(fightList.map(async (fight) => getFight(fight.id)));
		const participants = await getAllParticipants();
		const jurors = await getJurors();
		const teams = await getTeams();
		this.setState({ fights, participants, jurors, teams });
	}

	private toggleShowJurors = (fightId: number) => {
		if (fightId === this.state.showJurors) {
			this.setState({ showJurors: undefined });
		} else {
			this.setState({ showJurors: fightId });
		}
	};

	private getRound = (round: number) => {
		const fightsOfRound = _.sortBy(([] as Fight[]).concat(this.state.fights), ["name"]).filter(
			(fight) => fight.fightnr === round
		);
		const filteredFights = filterFights(fightsOfRound, this.state.selectedFilterItem);
		return (
			<div>
				<div {...styles.mobileMargin}>
					<H1 {...styles.title}>Round {round}</H1>
				</div>
				<div {...styles.container}>
					{filteredFights.map((fight: Fight) => (
						<div key={fight.id} {...styles.element}>
							<FightPlanCard
								fight={fight}
								showJurors={this.state.showJurors === fight.id}
								onToggleShowJurors={this.toggleShowJurors}
							/>
						</div>
					))}
				</div>
			</div>
		);
	};

	private onItemSelect = (item: FilterItem) => {
		this.setState({ selectedFilterItem: item });
	};
	private resetFilter = () => {
		this.setState({ selectedFilterItem: {} as FilterItem });
	};
	public render() {
		const filterItemsParticipant: FilterItem[] = this.state.participants.map((participant) => ({
			type: "Participant",
			text: participant.firstname + " " + participant.lastname,
			id: participant.id,
		}));
		const filterItemsJurors: FilterItem[] = this.state.jurors.map((juror) => ({
			type: "Juror",
			text: juror.firstname + " " + juror.lastname,
			id: juror.id,
		}));
		const filterItemsTeams: FilterItem[] = this.state.teams.map((team) => ({
			type: "Team",
			text: team.name,
			id: team.id,
		}));
		const filterItems: FilterItem[] = ([] as FilterItem[]).concat(
			filterItemsParticipant,
			filterItemsTeams,
			filterItemsJurors
		);
		return (
			<div>
				<div {...styles.mobileMargin}>
					<FightPlanFilter
						items={filterItems}
						onItemSelect={this.onItemSelect}
						resetFilter={this.resetFilter}
						activeText={
							this.state.selectedFilterItem
								? this.state.selectedFilterItem.text
								: "Select a Filter..."
						}
					/>
				</div>
				{this.state.fights.length > 0 ? this.getRound(1) : <Loading />}
				{this.state.fights.length > 0 ? this.getRound(2) : <div />}
				{this.state.fights.length > 0 ? this.getRound(3) : <div />}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Public/FightPlan.tsx